import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { menuGroups } from '@app/routes';

import { useLocation } from 'react-router-dom';
import { userManager } from '@app/utils/oidc';
import { BaseGatewayAuthImage } from '@app/utils/apiUrl';
// import { C } from 'node_modules/@fullcalendar/core/internal-common';

const MenuSidebar = () => {
    const [t] = useTranslation();
    // const account = getInfomationAccountFromToken();
    const [menuOpen, setMenuOpen] = useState({});
    const location = useLocation();
    // if (!location) return null;

    // 2) Lấy mappings + status
    const { listApiRoleMapping: mappings, status } = useSelector(
        (state) => state.apiRoleMapping
    );

    const dispatch = useDispatch();
    const itemAccountAuthInfo = useSelector((state) => state.account?.itemAccountAuthInfo);

    const resolveAvatarUrl = (path) => {
        if (!path) return '/img/default-profile.png';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        return `${BaseGatewayAuthImage}/${path.replace(/^\//, '')}`;
    };
    const avatarUrl = resolveAvatarUrl(itemAccountAuthInfo?.imageThumbnail);

    // 3) Trong khi đang loading, bạn có thể show skeleton hoặc trả về null
    // if (status === 'loading' || status === 'idle') {
    //     return (
    //         <aside className="main-sidebar sidebar-dark-primary elevation-4">
    //             <div className="sidebar">
    //                 <div style={{padding: '1rem', color: '#ccc'}}>
    //                     Đang tải menu...
    //                 </div>
    //             </div>
    //         </aside>
    //     );
    // }

    // local state for the current OIDC user
    const [oidcUser, setOidcUser] = useState(null);

    // load the user once on mount (and again whenever it silently renews)
    useEffect(() => {
        let mounted = true;

        // fetch the signed-in user (or null if not signed in)
        userManager.getUser().then((user) => {
            if (mounted) {
                setOidcUser(user);
                if (user?.profile?.sub) {
                    import('../../../store/reducers/account').then(({ getAccountAuthInfoByIdAccountAction }) => {
                        dispatch(getAccountAuthInfoByIdAccountAction(user.profile.sub));
                    });
                }
            }
        });

        // listen for silent-renew events to keep our state in sync
        const onUserLoaded = (user) => setOidcUser(user);
        userManager.events.addUserLoaded(onUserLoaded);

        return () => {
            mounted = false;
            userManager.events.removeUserLoaded(onUserLoaded);
        };
    }, []);

    // extract the array of role names from the OIDC user profile
    const userRoles = oidcUser?.profile?.role
        ? Array.isArray(oidcUser.profile.role)
            ? oidcUser.profile.role
            : [oidcUser.profile.role]
        : [];

    const normalizedUserRoles = userRoles.map((roleName) =>
        roleName?.toLowerCase().trim()
    );

    const canAccessGroup = (group) => {
        if (!group.requireRoles?.length) return true;

        return group.requireRoles.some((requiredRole) =>
            normalizedUserRoles.includes(requiredRole.toLowerCase().trim())
        );
    };

    // const havePermission = (controller) => {
    //     const maps = mappings.filter(
    //         (m) => m.controller.toLowerCase() === controller.toLowerCase()
    //     );
    //     if (!maps.length) return false;
    //     const allowed = maps.flatMap((m) =>
    //         m.lstAllowedRoles.map((r) => r.name)
    //     );
    //     return allowed.some((r) => userRoles.includes(r));
    // };

    // const havePermission = (controller) => {
    //     const maps = mappings.filter(
    //         (m) => m.controller.toLowerCase() === controller.toLowerCase()
    //     );

    //     if (!maps.length) return false;

    //     const allowed = maps.flatMap((m) =>
    //         m.lstAllowedRoles.map((r) => r.name)
    //     );

    //     return allowed.some((r) => userRoles.includes(r));
    // };

    // const havePermission = (route) => {
    //     // const maps = mappings.filter(
    //     //     (m) =>
    //     //         m.controller?.toLowerCase() === controller.toLowerCase() &&
    //     //         m.action === 'GetAllByPaging'
    //     // );

    //     const maps = mappings.filter(
    //         (m) =>
    //             m.controller?.toLowerCase() === route.controller.toLowerCase() && 
    //     );

    //     if (!maps.length) return false;

    //     const allowed = maps.flatMap((m) =>
    //         m.lstAllowedRoles?.map((r) => r.name) || []
    //     );

    //     return allowed.some((r) => userRoles.includes(r));
    // };

    const havePermission = (route) => {
        if (route?.path === URI_INTERNAL.TRA_CUU_CAN_BO_PATH) return true;
        if (!route?.controller) return false;

        const maps = mappings.filter((m) => {
            const sameController =
                m.controller?.toLowerCase() === route.controller.toLowerCase();

            if (!sameController) return false;

            // Nếu route có menuAction thì bắt buộc action phải khớp menuAction
            if (route.menuAction) {
                return (
                    m.action?.toLowerCase() === route.menuAction.toLowerCase()
                );
            }

            // Nếu không có menuAction thì giữ logic cũ: chỉ check controller
            return true;
        });

        if (!maps.length) return false;

        const allowed = maps.flatMap((m) =>
            m.lstAllowedRoles?.map((r) => r.name) || []
        );

        return allowed.some((r) => userRoles.includes(r));
    };

    const toggleMenu = (index) => {
        setMenuOpen((currentOpen) => ({
            ...currentOpen,
            [index]: !currentOpen[index]
        }));
    };

    const isPathInRoute = (pathname, routePath) => {
        if (pathname === routePath || pathname.startsWith(`${routePath}/`)) return true;
        if (routePath === URI_INTERNAL.DOTTUYENSINH_PATH) {
            if (pathname.startsWith(URI_INTERNAL.LOPDAOTAOLIENTUC_PATH) ||
                pathname.startsWith(URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH)) {
                return true;
            }
        }
        return false;
    };

    // const isPathInRoute = (pathname, routePath) =>
    //     pathname === routePath;

    return (
        <aside
            className="main-sidebar sidebar-dark-primary elevation-4"
            style={{ zIndex: '9993' }}
        >
            <Link to="/" className="brand-link">
                <img
                    src="/img/logo.png"
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{ opacity: '.8' }}
                />
                <span className="brand-text font-weight-light">
                    {/* {configData.NAME_OF_PROJECT} */}
                    HLDT & CDT 108
                </span>
            </Link>
            <div className="sidebar">
                <div className="user-panel sidebar-user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img
                            src={avatarUrl}
                            className="sidebar-user-avatar img-circle elevation-2"
                            alt="User"
                        />
                    </div>
                    <div className="info">
                        {/* <Link to="/profile" className="d-block">
                            {account.email ? account.email : account.username}
                        </Link> */}
                        <Link to="/profile" className="sidebar-user-name d-block">
                            {[itemAccountAuthInfo?.lastName, itemAccountAuthInfo?.middleName, itemAccountAuthInfo?.firstName].filter(Boolean).join(' ') || oidcUser?.profile?.preferred_username || oidcUser?.profile?.email || 'Guest'}
                        </Link>
                    </div>
                </div>
                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li className="nav-item">
                            <NavLink to="/" exact className="nav-link">
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p>{t('menusidebar.label.dashboard')}</p>
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to={URI_INTERNAL.DANHMUCPHANMEM_SHOW_PATH} className="nav-link">
                                <i className="nav-icon fas fa-laptop" />
                                <p>Trang chủ</p>
                            </NavLink>
                        </li>

                        {/* 2) Các nhóm động lấy từ menuGroups */}
                        {menuGroups.map((grp, idx) => {
                            if (!canAccessGroup(grp)) return null;

                            // lọc ra các route con được phép
                            const allowed = grp.children.filter((r) =>
                                havePermission(r)
                            );
                            if (allowed.length === 0) return null;

                            // const isGroupActive = allowed.some(
                            //     (r) => location.pathname === r.path
                            // );

                            const isGroupActive = allowed.some((r) =>
                                isPathInRoute(location.pathname, r.path)
                            );

                            return (
                                <li key={grp.title} className={`nav-item`}>
                                    <a
                                        // className="nav-link"
                                        className={`nav-link ${isGroupActive ? 'active' : ''
                                            }`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => toggleMenu(idx)}
                                    >
                                        <i className={`nav-icon ${grp.icon}`} />
                                        <p>
                                            {grp.title}
                                            <i
                                                className={`right fas fa-angle-${menuOpen[idx]
                                                    ? 'down'
                                                    : 'left'
                                                    }`}
                                            />
                                        </p>
                                    </a>
                                    <ul
                                        className={`nav nav-treeview ${menuOpen[idx] ? 'open' : ''
                                            }`}
                                        style={{
                                            // overflow: "hidden",
                                            display: 'block'
                                            // transition: "max-height 0.5s ease-out",
                                            // maxHeight: menuOpen[index]
                                            // ? '1000px'
                                            // : '0'
                                        }}
                                    >
                                        {allowed.map((r) => (
                                            <li
                                                key={r.path}
                                                className="nav-item"
                                            >
                                                <NavLink
                                                    to={r.path}
                                                    // exact={r.exact}
                                                    className="nav-link"
                                                    activeClassName="active"
                                                    isActive={(match, location) => {
                                                        if (match) return true;
                                                        if (r.path === URI_INTERNAL.DOTTUYENSINH_PATH) {
                                                            if (location.pathname.startsWith(URI_INTERNAL.LOPDAOTAOLIENTUC_PATH) ||
                                                                location.pathname.startsWith(URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH)) {
                                                                return true;
                                                            }
                                                        }
                                                        return false;
                                                    }}
                                                >
                                                    <i className="far fa-circle nav-icon" />
                                                    <p>{r.label}</p>
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
